package one.healthium.profile.navigation.update_height

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultUpdateHeightComponent(
    componentContext: ComponentContext,
    private val onCloseClicked: () -> Unit,
    private val onHeightUpdated: () -> Unit
) : UpdateHeightComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }

    override fun onHeightUpdated() {
        onHeightUpdated.invoke()
    }
}